import { ButtonBoxProps } from 'types/v1/main/form/buttonTypes';

  const ButtonBox = (props : ButtonBoxProps) =>
  {
    let gap= `gap-${props?.gap ?? 2}`;

    return (
      <div className={`centered-button-box ${gap}`}>
        {props.children}
      </div>  
    )
  }

export default ButtonBox;
